import axios from 'axios';
import { DutyChange, DutyChangePreviewResponse, CreatePreviewPayload } from '@/rennovation/planning-view/types/api/preview-response';

export class PreviewApiService {
	private baseUrl = '/api/previews';

	async getMyActive(): Promise<DutyChangePreviewResponse | null> {
		const response = await axios.get(`${this.baseUrl}/my`);
		return response.data ? response.data : null;
	}

	async createMine(payload: CreatePreviewPayload): Promise<DutyChangePreviewResponse> {
		const response = await axios.post(`${this.baseUrl}/my`, payload);
		return response.data;
	}

	async updateMine(id: string, payload: { changes: DutyChange[] }): Promise<DutyChangePreviewResponse> {
		const response = await axios.patch(`${this.baseUrl}/my`, payload);
		return response.data;
	}

	async publishMine(): Promise<void> {
		await axios.post(`${this.baseUrl}/my/publish`);
	}

	async cancelMine(): Promise<void> {
		await axios.post(`${this.baseUrl}/my/cancel`);
	}

	async undoChange(): Promise<void> {
		const response = await axios.patch(`${this.baseUrl}/my/undo`);
		return response.data;
	}

	async redoChange(): Promise<void> {
		const response = await axios.patch(`${this.baseUrl}/my/redo`);
		return response.data;
	}
}
